import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './multi.css'

const MultiListCard = () => {

    const cardDetaisl = [
        {
            title: "Security Controls",
            list: [
                {
                    list1: "Identity & Access:",
                    content: "SSO/OIDC, MFA, RBAC/least-privilege, break-glass logged"
                },
                {
                    list1: "Data Protection:",
                    content: "TLS 1.2+, at-rest encryption, PII redaction/tokenization, KMS/Vault secrets"
                },
                {
                    list1: "Network Posture:",
                    content: "VPC/VNet isolation, SG/NSG policies, private subnets, optional Private Link/Peering"
                },
                {
                    list1: "AppSec SDLC:",
                    content: "Threat modeling, code reviews, SAST/DAST, SBOM tracking"
                },
                {
                    list1: "Vulnerability Mgmt:",
                    content: "Monthly patch cycles, critical CVE SLAs, container image scanning"
                },
                {
                    list1: "Observability:",
                    content: "Structured logs/metrics/traces, immutable audit trails, incident replay"
                }
            ]
        },
        {
            title: "Compliance & Assurance",
            list: [
                {
                    list1: "Framework Alignment:",
                    content: "SOC 2 (Type I/II) mapping, ISO 27001 controls, ISO 27701 roadmap"
                },
                {
                    list1: "Privacy & Risk:",
                    content: "DPIA support, DPA/SCCs, GDPR/DPDP readiness"
                },
                {
                    list1: "Residency & Retention:",
                    content: "Region choice, configurable retention windows, deletion SLAs (evidence provided)"
                },
                {
                    list1: "Testing & Audits:",
                    content: "Annual 3rd-party pentest (summary on request), quarterly internal audits"
                },
                {
                    list1: "Vendor Risk:",
                    content: "Sub-processor list, security questionnaires (CAIQ/long-form), policy docs under NDA"
                },
                {
                    list1: "Procurement Pack:",
                    content: "Security brief, data-flow diagram, BCP/IR playbooks, access review samples"
                }
            ]
        }
    ]

    return (
        <>
            <Row>
                {
                    cardDetaisl.map((item, index) => {
                        return (
                            <Col className='card_margin' lg="6" key={index}>  
                                <Card className='multi_list_card'>
                                    <Card.Title className='multi_list_card_content_title'>{item.title}</Card.Title>
                                    <div className='multi_list_card_content'>
                                        <ul>
                                            {
                                                item.list.map((newitem, index) => {
                                                    return (
                                                        <li key={index}>
                                                            {newitem.list1}
                                                            <p className='list_subitem'>{newitem.content}</p>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                </Card>
                            </Col>
                        )
                    })
                }
            </Row>
        </>
    )
}

export default MultiListCard